const APP_ENV = typeof import.meta !== "undefined" && import.meta.env ? import.meta.env : {};

export const APP_MODE = APP_ENV.VITE_APP_MODE || "app";

export const isDemoMode = APP_MODE === "demo";

// Where forms, worksheets and certification records are sent when the user does not pick
// a recipient. This was previously hardcoded as one person's mailbox in ~15 files, so
// every default-routed record was tied to whether that individual still held the role.
// Set VITE_APP_INTAKE_EMAIL to a role-based address (e.g. intake@…) per deployment.
export const INTAKE_EMAIL = isDemoMode
  ? "demo@legalsupporthub.test"
  : (APP_ENV.VITE_APP_INTAKE_EMAIL || "ejackson@completelawsupport.com");

export const brand = {
  appName: isDemoMode ? "Legal Support Hub Demo" : "EAS Legal",
  appSubtitle: isDemoMode ? "Demo workspace for legal operations workflows" : "Staff portal for legal aid and casework workflows",
  wordmarkPrimary: isDemoMode ? "Legal Support" : "EAS",
  wordmarkSecondary: isDemoMode ? "Hub Demo" : "Legal",
  badgeText: isDemoMode ? "DEMO" : "EAS",
  intakeOrgName: isDemoMode ? "Demo Legal Services" : "EAS Legal",
  memoOrgName: isDemoMode ? "Demo Legal Services" : "EAS Legal",
  genericContactLine: INTAKE_EMAIL,
  genericWebsite: isDemoMode ? "www.legalsupporthub.demo" : "www.easlegal.com.au",
};
